import { useState } from "react";
import { toast } from "react-toastify";
import { signUp } from "services/accountService";
import { useNavigate } from "react-router-dom";
import Button from "components/ui/Button";

const SummaryTab = ({data,onBack,subscriptionPlans=[], onResetErrorMessage, onAddErrorMessages}) => {
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e?.preventDefault();

    //reset error messages before validating
    onResetErrorMessage();

    if(data.validation.isAccountDetailsValid && data.validation.isBusinessDetailsValid && data.validation.isUserDetailsValid){
      // Submit the data
      const {businessDetails,userDetails,accountDetails} = data;

      const payload ={
        userRegistration: {...userDetails, ...accountDetails},
        businessRegistration: {...businessDetails}
      }

      setIsLoading(true);
      const results = await signUp(payload);
      if(results?.success){
        toast.success("Registration successful! Please check your email to verify your account.");
        setIsLoading(false);
        navigate("/login");
      }
      else{
        toast.error(results?.message || "Registration failed. Please try again.");
        console.log(results);
        onAddErrorMessages(results?.errors || ["Registration failed. Please try again."]);
        setIsLoading(false);
      }
    }
    else{
      toast.error("Please complete all the previous tabs before submitting.");
    }
  };
  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto bg-white dark:bg-gray-900 rounded-xl shadow-lg p-6 space-y-6">
      <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">Summary Details</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">Registration summary.</p>
      <hr/>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">User Details</h2>


      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">First name</label>
          <span className="font-bold text-sm italic">{data.userDetails.name}</span>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Last name</label>
          <span className="font-bold text-sm italic">{data.userDetails.surname}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Contact number</label>
          <span className="font-bold text-sm italic">{data.userDetails.contactNo}</span>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Email</label>
          <span className="font-bold text-sm italic">{data.userDetails.email}</span>
        </div>
      </div>
      <hr/>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Account Details</h2>
      {/* Account Details Summary*/}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Username</label>
          <span className="font-bold text-sm italic">{data.userDetails.email}</span>
        </div>
    
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Password</label>
          <span className="font-bold text-sm italic">********</span>
        </div>
      </div>

      <hr/>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Business Details</h2>
      {/* Business Details Summary*/}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Business name</label>
          <span className="font-bold text-sm italic">{data.businessDetails.name}</span>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Subscription Plan</label>
          <span className="font-bold text-sm italic">{subscriptionPlans.find(plan => plan.id === data.businessDetails.subscriptionId)?.name}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Contact number</label>
          <span className="font-bold text-sm italic">{data.businessDetails.contactNo}</span>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Email</label>
          <span className="font-bold text-sm italic">{data.businessDetails.email}</span>
        </div>
      </div>

      <div className="flex items-center justify-between gap-3">
        <Button
          type="button"
          onClick={() => onBack()}
          className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 transition"
        >
          Back
        </Button>

        <Button
          type="submit"
          className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
          disabled={isLoading}
          loading={isLoading}
        >
          Submit
        </Button>
      </div>
    </form>
  );
};

export default SummaryTab;